import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringDEFromNumber',
  standalone: false
})
export class StringDEFromNumberPipe implements PipeTransform {
  transform(value: number | undefined, digits = 2): string {
    if (this.isNumeric(value)) {
      // console.log("is numeric: ",value)
      return this.format(value, digits);
    } else {
      // console.log("not numeric: ",value)
      if (!value) {
        return '';
      }
      return String(value);
    }
  }

  private format(num: unknown, digits: number) {
    const value = String(num);

    // Decision 11.09.2024: always german decimal signs are used
    const thousands_separator = '.';
    const decimal_separator = ',';

    let result = '';
    const sap_decimal_separator = '.';
    const valueSplit = value.split(sap_decimal_separator);
    const intValue = valueSplit[0];
    result = intValue.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator);

    if (valueSplit.length == 1) {
      result = result + decimal_separator + '0'.repeat(digits);
    }

    if (valueSplit.length == 2) {
      result = result + decimal_separator + valueSplit[1].padEnd(digits, '0');
    }

    return result;
  }

  private isNumeric(value: unknown) {
    return typeof value === 'number' && !isNaN(value);
  }
}
